module.exports = __webpack_public_path__ + "tt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tt.svg
// module id = 1108
// module chunks = 0